import { render } from "./ReceptionsComponent.vue?vue&type=template&id=70733f56"
import script from "./ReceptionsComponent.vue?vue&type=script&lang=js"
export * from "./ReceptionsComponent.vue?vue&type=script&lang=js"

import "./ReceptionsComponent.vue?vue&type=style&index=0&id=70733f56&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__